import { serviceProjectLayout } from '@atlassian/jira-service-project-layout/src/index.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getServiceDeskNavigationResources } from '@atlassian/jira-router-resources-service-desk-common/src/index.tsx';
import ErrorPagesNotFound from '@atlassian/jira-router-routes-common/src/ui/error-pages/not-found/index.tsx';
import { helpCenterSettingsWidgetConfigurationInstallRoute } from '@atlassian/jira-router-routes-help-center-settings-routes/src/helpCenterSettingsWidgetConfigurationInstallRoute.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { HelpCenterSettingsWidgetConfigurationInstallEntryPoint } from './ui/widget-configuration/install-entry.tsx';
import { navigation } from './common/constants.tsx';

export const helpCenterSettingsWidgetConfigurationInstallRouteEntry = createEntry(
	helpCenterSettingsWidgetConfigurationInstallRoute,
	() => ({
		group: 'helpcenter-settings',
		perfMetricKey: 'customer-service.widget-configuration.install',
		layout: serviceProjectLayout,
		navigation,
		component: ErrorPagesNotFound,

		entryPoint: () => {
			if (
				!fg('csm_agent_config_widget_configuration_embed_page') ||
				!fg('csm_agent_config_widget_configuration_tab_routes')
			) {
				return undefined;
			}
			return HelpCenterSettingsWidgetConfigurationInstallEntryPoint;
		},

		resources: [...getServiceDeskNavigationResources()],

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-help-center-settings-entries/src/helpCenterSettingsWidgetConfigurationInstallRouteEntry.tsx',
				whichExportToUse: 'helpCenterSettingsWidgetConfigurationInstallRouteEntry',
			},

			enabled: true,
		},
	}),
);
